export const loginAttributeLabels = {
  phoneNumber: {
    id: 'Authentication.Login.Patient.PhoneNumber.Label',
    defaultMessage: '** Phone Number',
  },
};
